import React from 'react';
import {get} from 'lodash';
import Experiment from '@homeaway/react-experiment';
import CancelTripModal from '../../CancelTripModal/CancelTripModal';
import {AUTO_CANCELLATION, CANCELLATION_REQUEST} from '../constants';
import actions from '../../allowedActions';

const CancelTripModalContainer = (props) => {
    const {
        actionLocation,
        conversationId,
        cancellationLabel,
        data,
        fetch,
        fullLocale,
        locale,
        location,
        priceDetails,
        shortDisplayName,
        translations,
    } = props;
    const {REQUEST_TO_CANCEL, SELF_SERVICE_CANCEL} = actions;

    const {currentStateOfStay, stateOfStayData} =
        data.getTravelerStay.stayState;
    const autoCancellationSummary =
        stateOfStayData?.autoCancellationSummary || {};
    const {existingRequest, refund} = stateOfStayData || {};
    const {refundableTotalDecimalAmount} = refund || {};

    const allowedActions =
        currentStateOfStay.actions?.map((action) => action.id) || [];
    const allowsAutoCancellation = allowedActions.includes(SELF_SERVICE_CANCEL);
    const allowsCancellationRequest =
        allowedActions.includes(REQUEST_TO_CANCEL);
    const hasCancellationRequest = !!existingRequest?.state;
    const cancelType = allowsAutoCancellation
        ? AUTO_CANCELLATION
        : CANCELLATION_REQUEST;
    const clientRequestId = get(
        data,
        'recommendedListingResponse.clientRequestId',
        ''
    );
    const recommendedListings = get(
        data,
        'recommendedListingResponse.recommendedListings',
        []
    );
    const cancellationReasons = data.cancellationReasons;
    const filteredCategory =
        cancellationReasons &&
        cancellationReasons.filter(
            (reason) => reason.category !== 'DISASTER_OR_EMERGENCY'
        );
    return !hasCancellationRequest &&
        (allowsAutoCancellation || allowsCancellationRequest) ? (
        <div
            className="CancelSection__section-content"
            data-testid="button-container"
        >
            <Experiment
                name={'VRBO_STX_COVID_CANCELLATION_REASON'}
                variant={'off'}
            >
                <CancelTripModal
                    actionLocation={actionLocation}
                    autoCancellationSummary={autoCancellationSummary}
                    cancellationReasonsByCategory={filteredCategory}
                    cancellationType={cancelType}
                    conversationId={conversationId}
                    fullLocale={fullLocale}
                    locale={locale}
                    location={location}
                    manageBookingLabel={cancellationLabel}
                    onComplete={fetch}
                    priceDetails={priceDetails}
                    recommendedListings={recommendedListings}
                    refundableTotalDecimalAmount={refundableTotalDecimalAmount}
                    requestMarker={clientRequestId}
                    shortDisplayName={shortDisplayName}
                    translations={translations}
                />
            </Experiment>
            <Experiment
                name={'VRBO_STX_COVID_CANCELLATION_REASON'}
                variant={'on'}
            >
                <CancelTripModal
                    actionLocation={actionLocation}
                    autoCancellationSummary={autoCancellationSummary}
                    cancellationReasonsByCategory={cancellationReasons}
                    cancellationType={cancelType}
                    conversationId={conversationId}
                    fullLocale={fullLocale}
                    locale={locale}
                    location={location}
                    manageBookingLabel={cancellationLabel}
                    onComplete={fetch}
                    priceDetails={priceDetails}
                    recommendedListings={recommendedListings}
                    refundableTotalDecimalAmount={refundableTotalDecimalAmount}
                    requestMarker={clientRequestId}
                    shortDisplayName={shortDisplayName}
                    translations={translations}
                />
            </Experiment>
        </div>
    ) : null;
};

export default CancelTripModalContainer;
